import BaseApi from "@/api/baseApi";
export default {
  add(form) {
    return BaseApi.put('api-piglet/api/from-hire/v1/transaction', form);
  },
  complete(delivryId, context) {
    return BaseApi.post(`api-piglet/api/from-hire/v1/${context}/complete/${delivryId}`);
  },
  read(deliveryId) {
    return BaseApi.get(`api-piglet/api/from-hire/v1/transactions/${deliveryId}`);
  },
  readSingle(deliveryId, timeStamp) {
    return BaseApi.get(`api-piglet/api/from-hire/v1/transactions/${deliveryId}/${timeStamp}`);
  }
}
